import React from 'react';

import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons'

import { StaticRouter, withRouter } from 'react-router-dom';
import { Avatar, Select } from 'antd';
import Lang from '../../../lang'

import FormnavBar from '../../../components/common/wizard_navbar'
import WizardLeft from '../../../components/common/wizard_left'
import services from '../../../services';
import $, { data } from 'jquery';

import { toast } from 'react-toastify';
import { Row } from 'antd';
import TlkTable from '../../../components/tlelrik/table/tlkTable';
import Swal from "sweetalert2";

const { Option } = Select;
const queryString = require('query-string');

const parcel = []

let IVDPFORMDATA = {
    "areaCoberta": "",
    "capacidadeVenda": "",
    "capacity": "",
    "checkbox": [],
    "codEntrFiscal": "",
    "codInstalacao": "",
    "codInstalacaoVinica": "",
    "codigoPostalExtenso": "",
    "dataCriado": "",
    "descricaoAtividade": "",
    "descricaoProprietario": "",
    "designacaoSocial": "",
    "desparc": "",
    "dicofre": "",
    "entidadePrincipal": "",
    "entreposto": [],
    "entrepostolist": [],
    "etar": "",
    "fax": "",
    "freguesiaCodigo": "",
    "geocodigo": "",
    "idAtividade": [],
    "idEntidade": "",
    "idEntreposto": "",
    "idEstado": "",
    "idIdentificacaoProprietario": "",
    "idInstalacaoVinica": "",
    "idTipoInstalacao": "",
    "idUtilizadorInstalacao": "",
    "instalacaoVinica": "",
    "licenceIndustrial": "",
    "licenciamentoIndustrial": "",
    "lugar": "",
    "medida1": "",
    "medida2": "",
    "Altura do bojo (m)": "",
    "medida3": "",
    "medida4": "",
    "medida5": "",
    "mode": "",
    "morada": "",
    "numLCIIndustrial": "",
    "numeroEntrepostoFiscal": "",
    "numeroLicIndustrial": "",
    "numparant": "",
    "observacoes": "",
    "origemmcp": "",
    "owner": {},
    "selfEntreposto": "",
    "telefone": "",
    "tipoCurrent": "",
    "tipooptionvalue": ""
}

let combolistrequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};

let ownerArray = [
    "nif",
    "numeroNIFAP",
    "paisId",
    "nif",
]

let columnkeyMap = {
    "designacaoSocial": "Designação",
    "id": "Código",
    "morada": "Morada",
    "localidade": "Lugar",
    "codigoPostalExtenso": "Código Postal",
    "estadoCodigo": "Estado",
    "Status": "Presente em IVDP"

}

let finalizeArray = [
    "designacaoSocial",
    "email",
    "fax",
    "telefone",
]

let compareFields = [
    "codigoPostalExtenso",//
    "freguesiaCodigo",//
    "localidade",//
    "morada",//
]

let filters = {
    "NumInstalacao": null,
    "Designacao": null,
    "TipoInstalacao": null,
    "Estado": null,
    "nome": null,
    "numero": null,
    "DataCriadoStart": null,
    "DataCriadoEnd": null,
    "DataModificadoStart": null,
    "DataModificadoEnd": null,
    "Geocod": null,
    "Concelho": null,
    "NomeEntreposto": null,
    "Distrito": null,
    "Fregusia": null
}

let styleBtn = {
    padding: '15px !important'
}

class IVVFrom extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            message: '',
            entidade: {}
        }
    }


    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        // let data = {}
        // data["ivvcode"] = "503307220"
        // this.setState({
        //     data
        // })
    }

    onChange = (e) => {
        let data = { ...this.state.data }
        data[e.target.name] = e.target.value;
        this.setState({ data });
    }

    afterValidate = () => {
        let { data } = this.state
        if (data.ivvcode) {
            if (isNaN(+data.ivvcode)) {
                toast.error('por favor insira apenas dígitos')
                return
            }
            this.validateIVVCODE(data)
        }
        else {
            toast.error('campo é obrigatório')
        }
    }

    validateIVVCODE = async (data) => {

        let res = await services.apiCall.requestApi('InstalacaoVinica/ValidateIVV', { nif: +data.ivvcode }, 'post')
        let entidade = await services.EntityList.getEntityList('parcel', null, +data.ivvcode + '')
        if (entidade && entidade.entity_row && entidade.entity_row[data.ivvcode]) {
            entidade = entidade.entity_row[data.ivvcode]
        }
        // console.log("res",res,"parsedJson",JSON.parse(res),"parsedJson +",JSON.parse(res+""))
        let parsedResponse = JSON.parse(res + '')

        let ivvArray = []
        let ivdpArray = []
        let entityDetails = {}
        let toBeCompared = null

        let resIVDP
        let requestIVDP = { ...combolistrequest }
        requestIVDP["Filters"] = { ...filters }
        requestIVDP["Filters"]["NumInstalacao"] = data.ivvcode

        if (parsedResponse.mensagem == "OK") {
            let instalacao =
                parsedResponse &&
                parsedResponse.entidades &&
                parsedResponse.entidades.entidade &&
                parsedResponse.entidades.entidade.instalacoes &&
                parsedResponse.entidades.entidade.instalacoes.instalacao;

            if (!instalacao) {
                toast.error("there is no installation in the IVV register");
                return;
            }

            const arr = Array.isArray(instalacao) ? instalacao : [instalacao];

            ivvArray = this.checkForAtivo(arr);

            console.log("the array of installtions is ", ivvArray, entityDetails)
            resIVDP = await services.apiCall.requestApi('SIVDP/P_instalacao_vinica_listinstalationsbyname', requestIVDP, 'post')
            if (resIVDP) {
                console.log("the ivdp res ", resIVDP)
                if (Array.isArray(resIVDP) && resIVDP.length > 0) {
                    ivdpArray = [...resIVDP]
                    ivdpArray.map((juice) => {
                        ivvArray.map((fruit, index) => {
                            if (juice.codigoIVV === fruit.id) {
                                ivvArray[index].geocodigo = juice.geocodigo
                            }
                        });
                    });
                    toBeCompared = true
                }
                else {
                    toBeCompared = false
                }
            }
            else {
                toBeCompared = false
            }
            this.setState({
                ivvArray,
                ivdpArray,
                entityDetails,
                entidade
            }, () => {
                console.log("to be compared, ", toBeCompared)
                this.compareAndCheck(toBeCompared)
                //console.log("the comparison begins ", ivvArray, ivdpArray)
            })
        }
        else {
            toast.error(parsedResponse.mensagem)
        }
        console.log("res", JSON.parse(res + ''))
    }

    checkForAtivo = (arr) => {
        let newArr = arr.filter(obj => {
            if (obj.estadoCodigo === "ATIVO") return true
            else return false
        })
        return newArr
    }

    compareAndCheck = (toBeCompared) => {
        if (toBeCompared) {
            this.compareArrays()
        }
        else {
            this.finalizeArray(this.state.ivvArray)
        }
    }

    compareArrays = () => {
        const ivvArray = [...this.state.ivvArray]
        const ivdpArray = [...this.state.ivdpArray]
        const newIvvArray = []

        ivvArray.forEach(ivvInst => {

            const ivvMorada = (ivvInst.morada || '').trim().toUpperCase()
            const ivvLugar = (ivvInst.localidade || '').trim().toUpperCase()
            const ivvFreguesia = ivvInst.freguesiaCodigo || ''

            const match = ivdpArray.find(ivdpInst => {

                const ivdpMorada = (ivdpInst.morada || '').trim().toUpperCase()
                const ivdpLugar = (ivdpInst.lugar || '').trim().toUpperCase()
                const ivdpFreguesia = ivdpInst.freguesiaCodigo || ''

                return (
                    ivvMorada === ivdpMorada &&
                    ivvLugar === ivdpLugar &&
                    ivvFreguesia === ivdpFreguesia
                )
            })

            const inst = {
                ...ivvInst
            }

            if (match) {
                // A instalação já existe na BD
                inst.Status = "Sim"

                inst.idInstalacaoVinica =
                    match.idInstalacaoVinica

                // Se a BD tiver geocodigo, preferir o da BD
                if (match.geocodigo) {
                    inst.geocodigo = match.geocodigo
                }

                // Guardar os dados da BD para posteriormente
                // preencher o formulário com eles
                inst.dbData = {
                    ...match
                }

            } else {
                // A instalação não existe na BD
                inst.Status = "Não"
                inst.idInstalacaoVinica = ""

                // Não há dados BD
                inst.dbData = null
            }

            newIvvArray.push(inst)
        })

        this.finalizeArray(newIvvArray)
    }

    finalizeArray = (arr) => {
        console.log("final array 800", arr)
        let newArr = []
        let { entidade } = this.state
        arr.map(inst => {

            if (!inst.designacaoSocial && inst.morada) {
                inst.designacaoSocial = inst.morada
            }

            //coddis, codcon, codfrg
            inst["coddis"] = inst.freguesiaCodigo.substring(0, 2)
            inst["codcon"] = inst.freguesiaCodigo.substring(2, 4)
            inst["codfrg"] = inst.freguesiaCodigo.substring(4, 6)

            //owner
            let owner = { ...this.state.entidade }
            inst["owner"] = { ...owner }
            inst["owner"]["tipoIdentificacao"] = 1
            inst["owner"]["ownernif"] = owner.nif

            //LIC checkbox
            let checkbox = {}
             if(inst["semLicenciamentoIndustrial"] === "false") {
                checkbox["LicenciamentoIndustrial"] = true
            }
            else {
                checkbox["LicenciamentoIndustrial"] = false
            }

            inst["checkbox"] = { ...checkbox }
            if (!inst["Status"]) {
                inst["Status"] = "Não"
            }

            //delete atividades
            // delete inst.atividades
            inst = { ...inst, ...this.state.entityDetails }
            newArr.push(inst)
        })
        this.setState({
            newArr,
            totalcount: newArr.length
        }, () => {
            this.forTlkTable()
        })
    }

    forTlkTable = () => {
        let newArr = [...this.state.newArr]
        newArr.map(inst => {
            Object.keys(columnkeyMap).map(key => {
                inst[columnkeyMap[key]] = inst[key]
            })
        })
        this.setState({
            newArr
        }, () => {
            this.createTabel()
        })
    }

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
    });

    ActionPerform = (action, row) => {
        console.log("800 action in the ivvform", row)
        if (action === "insert") {
            // if(row.idInstalacaoVinica) {
            //     this.goToForm("editForm", row)
            // }
            // else {
            this.goToForm("validateIVV", row)
            //}
        }
        if (action == 'AddAgente') {
            this.insertAgent(row);
        }
    }


    insertAgent = async (dados) => {
        Swal.fire({
            title: 'Deseja adicionar este utilizador à instalação vínica?',
            showCancelButton: true,
            confirmButtonText: 'Aceitar',
            denyButtonText: 'Recusar',
            cancelButtonText: "Cancelar"
        }).then((result) => {
            (async () => {

                if (result.isConfirmed) {
                    var Request = {
                        CodigoIVV: dados.Código,
                        idInstalacaoVinica: dados.idInstalacaoVinica,
                        situacaoCodigo: dados.situacaoCodigo,
                        idEntidade: this.state.entidade.codEntidade,
                        loggedUser: window.localStorage.getItem('username')
                    }

                    console.log(Request)
                    let res = await services.apiCall.requestApi('InstalacaoVinica/AddAgenteEconomico', Request, "post");
                    if (res) {
                        this.afterValidate()

                        Swal.fire({
                            icon: "success",
                            text: "Utilizador adicionado com sucesso",
                            showConfirmButton: false,
                            timer: 1500
                        });

                    } else {
                        Swal.fire({
                            icon: 'error',
                            text: 'Não foi possível adicionar o utilizador',
                        })
                    }
                }

            })();
        })
    };

    createTabel = () => {
        let actionbuttons = { IVVvalidate: "Inserir Instalação Vínica" }
        let telkikTable = <TlkTable
            date={new Date()}
            noDownloadButton={true}
            modulename={"fordefault"}
            list={this.state.newArr}
            actionbuttons={actionbuttons}
            columnlist={this.columnlist}
            totalcount={this.state.totalcount}
            ActionPerform={(action, id) => this.ActionPerform(action, id)}
        />
        this.setState({
            telkikTable: telkikTable
        })
    }

    getIVDPFormData = (row) => {

        let source = row

        // =====================================================
        // 1. SE EXISTE NA BD -> usar dados da BD
        // 2. SE NÃO EXISTE -> usar dados do IVV
        // =====================================================
        if (row.Status === "Sim" && row.dbData) {
            source = {
                ...row,
                ...row.dbData
            }
        }

        // =====================================================
        // CÓDIGO DA FREGUESIA
        // IVV: freguesiaCodigo = 6 dígitos
        // Exemplo: 170804
        // 17 = distrito
        // 08 = concelho
        // 04 = freguesia
        // =====================================================

        const freguesiaCodigo =
            source.freguesiaCodigo ||
            source.dicofre ||
            ''

        const dicofre = String(freguesiaCodigo)

        const coddis = dicofre.substring(0, 2)
        const codcon = dicofre.substring(2, 4)
        const codfrg = dicofre.substring(4, 6)


        // =====================================================
        // ATIVIDADES
        // =====================================================

        let atividades = source.atividades

        if (
            atividades &&
            atividades.atividade
        ) {

            const atividadeArray =
                Array.isArray(atividades.atividade)
                    ? atividades.atividade
                    : [atividades.atividade]

            atividades = atividadeArray
                .map(item => item.tipoAtividadeId)
                .filter(Boolean)
                .join(',')
        }


        // =====================================================
        // FORM DATA
        // =====================================================

        let IVDPFORMDATA = {}

        IVDPFORMDATA['telefone'] =
            source.telefone || ''

        IVDPFORMDATA['email'] =
            source.email || ''

        IVDPFORMDATA['fax'] =
            source.fax || ''


        // =====================================================
        // ENTIDADE
        // =====================================================

        IVDPFORMDATA['nif'] =
            source.nif ||
            (source.owner && source.owner.nif) ||
            ''

        IVDPFORMDATA['idEntidade'] =
            source.idEntidade ||
            (source.owner && source.owner.codEntidade) ||
            ''


        IVDPFORMDATA['designacaoSocial'] =
            source.designacaoSocial ||
            source.morada ||
            ''


        // =====================================================
        // INSTALAÇÃO
        // =====================================================

        IVDPFORMDATA['codigoIVV'] =
            source.codigoIVV ||
            source.id ||
            ''


        IVDPFORMDATA['idInstalacaoVinica'] =
            source.idInstalacaoVinica || ''


        IVDPFORMDATA['situacaoCodigo'] =
            source.situacaoCodigo || ''


        IVDPFORMDATA['estadoCodigo'] =
            source.estadoCodigo || ''


        // =====================================================
        // MORADA
        // =====================================================

        IVDPFORMDATA['morada'] =
            source.morada || ''


        IVDPFORMDATA['lugar'] =
            source.lugar ||
            source.localidade ||
            ''


        IVDPFORMDATA['codigoPostal'] =
            source.codigoPostal ||
            source.codigoPostalExtenso ||
            ''


        // =====================================================
        // LOCALIZAÇÃO
        // =====================================================

        IVDPFORMDATA['dicofre'] =
            dicofre

        IVDPFORMDATA['coddis'] =
            coddis

        IVDPFORMDATA['codcon'] =
            codcon

        IVDPFORMDATA['codfrg'] =
            codfrg


        // =====================================================
        // NOMES DA LOCALIZAÇÃO
        // Estes podem ser preenchidos posteriormente pelo
        // LocationFunction através dos códigos.
        // =====================================================

        IVDPFORMDATA['distrito'] =
            source.distrito || ''

        IVDPFORMDATA['concelho'] =
            source.concelho || ''

        IVDPFORMDATA['freguesia'] =
            source.freguesia || ''
        // =====================================================
        // LICENCIAMENTO INDUSTRIAL
        // semLicenciamentoIndustrial = "false" -> CHECKED
        // semLicenciamentoIndustrial = "true"  -> NÃO CHECKED
        // =====================================================

        const licenciamentoIndustrial =
            source.semLicenciamentoIndustrial === "false"

        // Para o WizardVínica
        IVDPFORMDATA['LicenciamentoIndustrial'] =
            licenciamentoIndustrial ? "true" : "false"

        // Para o checkbox
        IVDPFORMDATA['checkbox'] = {
            LicenciamentoIndustrial: licenciamentoIndustrial
        }


        // =====================================================
        // ENTREPOSTO FISCAL
        // =====================================================

        IVDPFORMDATA['numeroEntrepostoFiscal'] =
            source.numeroEntrepostoFiscal || ''


        // =====================================================
        // ATIVIDADES
        // =====================================================

        IVDPFORMDATA['atividades'] =
            atividades || ''


        // =====================================================
        // OWNER
        // =====================================================

        IVDPFORMDATA['owner'] = {
            ...(source.owner || {}),
            tipoIdentificacao: 1,
            ownernif:
                source.nif ||
                (source.owner && source.owner.nif) ||
                ''
        }


        return IVDPFORMDATA
    }


    goToForm = (type = '', row = null) => { // got to the insert form page
        let newUrl = '/inseririnstalacaovínica'
        // console.log("800 row in the gotofrom",queryString.stringify(newRow))
        if (type === "validateIVV") {
            let newRow = this.getIVDPFormData(row);


            if (newRow.atividades && Array.isArray(newRow.atividades.atividade)) {
                var atividadearray = "";
                for (let index = 0; index < newRow.atividades.atividade.length; index++) {
                    if (atividadearray == "") {
                        atividadearray = newRow.atividades.atividade[index].tipoAtividadeId;
                    } else {
                        atividadearray = atividadearray + ',' + newRow.atividades.atividade[index].tipoAtividadeId;
                    }
                }
                newRow.atividades = atividadearray
            } else {
                if (newRow.atividades.atividade) {
                    newRow.atividades = newRow.atividades.atividade.tipoAtividadeId;
                }
            }


            this.props.history.push({
                pathname: newUrl,
                search: 'from=' + type + "&" + queryString.stringify(newRow),
                state: { ...newRow }
            });
        }
        else if (type === "editForm") {
            this.props.history.push({
                pathname: newUrl,
                search: 'idInstalacao=' + row.idInstalacaoVinica,
                state: {}
            })
        }
        else {
            this.props.history.push({ pathname: newUrl, state: { isInEdit: 'false' } })
        }
    }

    goBack = () => {
        let topBarMenu = this.props.topBarMenu || {}

        this.props.history.push({
            pathname: this.props.to,
            state: { topBarMenu: topBarMenu }
        })
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {

        return (
            <div className="right-section">
                <div className="bg-white middle p20" id="Instalações">
                    <h5>Verificação de dados no IVV</h5>
                    <p>
                        Introduza o NIF do utilizador da instalação para validação de dados. Caso este seja válido serão apresentados os dados registados no IVV.
                    </p>
                    <div className="form-group position-relative">
                        <div className="input-box active-grey form-inline">
                            <input
                                style={{ width: "21%", height: "32px" }}
                                //style={{ height: "32px" }}
                                value={this.state.data.ivvcode || this.state.nifNum || ""}
                                name={"ivvcode"}
                                placeholder="NIF Entidade"
                                onChange={this.onChange}
                                className="form-control"
                            />
                            {
                                this.state.message &&
                                <span>{this.state.message}</span>
                            }
                            <Button primary={true} className="ml-3 success btn-ivdp-primary mr-2" onClick={() => this.afterValidate()} >Validar IVV</Button>
                        </div>
                    </div>
                    {/* <Button className="success k-primary btn-ivdp-secondary btn-theme mr-2" onClick={this.goBack} >Cancelar</Button>
                    <Button primary={true} className="success btn-ivdp-primary mr-2" onClick={()=>this.goToForm()} >Não tem</Button> */}
                </div>
                {
                    this.state.newArr &&
                    <div className="table-responsive table-section">
                        <h3>A Instalação vínica possui {this.state.totalcount}  vasilhas </h3>
                        {
                            this.state.telkikTable
                        }
                    </div>
                }

            </div>
        )
    }
}

export default withRouter(IVVFrom);